import React, {useContext} from 'react';
import {customerDataContext} from '../../contexts/CustomerDataProvider';
import './legal.scss';
import Loading from '../Loading/Loading';
import { productTypes } from '../../utils/productHelpers';
import { useFeatureFlags } from '../FeatureFlags/withFeatureFlags';

import documentIcon from '../../assets/images/document.svg';

// const customerOwnsAccount = (customer, accountType) => {
//   return customer.accounts.some(a => a.product.productType === accountType);
// };

// const buildDocumentUrl = document => {
//   return `${window.raeEnv.documentsUrl}${document}`;
// }

const Legal = () => {
  const data = useContext(customerDataContext);
  const [featureEnabled] = useFeatureFlags();

  if (!data || data.loading || !data.data) return <Loading message="We're loading your details..." />;

  const customer = data.data.customer;
  const hasDisaAccount = featureEnabled('EnableFisaMaturity') && customer?.accounts?.some(account =>
    account.product?.productType === productTypes.InstantAccessCashISA
  ) === true;

  return (
    <div className="legal ">
      <h1 className="legal__title legal__title--with-sub">
        Legal
      </h1>
      <div className="legal__paragraph">All of the current and historic terms for all of your accounts, including our general terms, are available to read and download if you need them.</div>
      {/* <a href={buildDocumentUrl('general-terms-JUL21.pdf')} className="legal__document-link" target="_blank">
        <img src={documentIcon} />
        General Terms
      </a>
      {customerOwnsAccount(customer, productTypes.EasyAccess) &&
        <a href={buildDocumentUrl('ofs-product-terms-APR20.pdf')} className="legal__document-link" target="_blank">
          <img src={documentIcon} />
          Product Terms: Online Flexi Saver
        </a>
      }
      {customerOwnsAccount(customer, productTypes.FixedTerm) &&
        <a href={buildDocumentUrl('frs-product-terms-JUL21.pdf')} className="legal__document-link" target="_blank">
          <img src={documentIcon} />
          Product Terms: Fixed Rate Saver
        </a>
      } */}
        <>
          <a href={`${window.raeEnv.productPageUrl}/current-and-historic-terms${featureEnabled('EnableFisaMaturity') && hasDisaAccount ? '?hasDisaAccount=true' : ''}`} target="_blank" className="legal__document-link legal__document-link--no-margin" rel="noreferrer">
            Go to the terms page <span className="legal__document-link__arrow">&gt;</span>
          </a>
          <p className="legal__paragraph">
            This link will open a new tab that you can close when you're done. You'll stay logged in here.
          </p>
        </>
      <h2 className="legal__title legal__title--no-subtitle">
        Other Documentation
      </h2>
      <a href="https://www.investec.com/content/dam/united-kingdom/downloads-and-documents/private-banking/FSCS-Information-and-Exclusions.pdf" target="_blank" className="legal__document-link" rel="noreferrer">
        <img src={documentIcon} />
        FSCS Information Sheet
      </a>
      <p className="legal__paragraph">
        As we are covered by the Financial Services Compensation Scheme, savings with Investec Bank plc. are covered up to £120,000 per person.
      </p>
    </div>
  );
}

export default Legal;
